export default __webpack_public_path__ + "static/media/product-image-16.791a86b2.jpg";